import img15a from '../../../assets/gallery/15f//15f-01-HOME_Vista-de-exhibicion_Inscripción-en-la-Tierra.jpg';
import img15b from '../../../assets/gallery/15f/15f-02_Vista-de-Instalacion-Medidas-variables.jpg';
import img15c from '../../../assets/gallery/15f/15f-03_Tres-líneas-2015-300x200cm-oleo-sobre-papel.jpg';
import img15d from '../../../assets/gallery/15f/15f-04_Serie-Blanca-6-2015-300x200cm-oleo-sobre-papel.jpg';
import img15e from '../../../assets/gallery/15f/15f-05_Serie-Blanca-7-2015-300x200cm-oleo-sobre-papel.jpg';
import img15f from '../../../assets/gallery/15f/15f-06_Vista-de-Instalacion-Medidas-variables.jpg';
import img15g from '../../../assets/gallery/15f/15f-07_Vista-de-Instalacion-Medidas-variables.jpg';
import img15h from '../../../assets/gallery/15f/15f-08_Chapa-10-2015-Barra-de-grafito-6B-sobre-papel-90gr-1257x914mm.png';
import img15i from '../../../assets/gallery/15f/15f-09_Chapa-10-2015-Barra-de-grafito-6B-sobre-papel-90gr-863x596mm.png';

export const dataImages = [
  {
    id: 1,
    title: "",
    dimensions: "",
    pictureSrc: img15a,
    description: "2015",
    orientation: "h"
  },
  {
    id: 2,
    title: "",
    dimensions: "",
    pictureSrc: img15b,
    description: "2015",
    orientation: "h"
  },
  {
    id: 3,
    title: "",
    dimensions: "300 x 200 cm",
    pictureSrc: img15c,
    description: "2015",
    orientation: "v"
  },
  {
    id: 4,
    title: "",
    dimensions: "300 x 200 cm",
    pictureSrc: img15d,
    description: "2015",
    orientation: "v"
  },
  {
    id: 5,
    title: "",
    dimensions: "300 x 200 cm",
    pictureSrc: img15e,
    description: "2015",
    orientation: "v"
  },
  {
    id: 6,
    title: "",
    dimensions: "",
    pictureSrc: img15f,
    description: "2015",
    orientation: "v"
  },
  {
    id: 7,
    title: "",
    dimensions: "",
    pictureSrc: img15g,
    description: "2015",
    orientation: "h"
  },
  {
    id: 8,
    title: "",
    dimensions: "125,7 x 91,4 cm",
    pictureSrc: img15h,
    description: "2015",
    orientation: "v"
  },
  {
    id: 9,
    title: "",
    dimensions: "86,3 x 59,6 cm",
    pictureSrc: img15i,
    description: "2015",
    orientation: "v"
  },
].sort(() => Math.random() - 0.5);

export const dimensionsH = [
  { width: "820" },
  { width: "730" },
  { width: "700" },
  { width: "650" },
  { width: "539" },
  { width: "444" },
  { width: "400" },
  { width: "382" },
];


export const dimensionsV = [
  { width: "820" },
  { width: "730" },
  { width: "700" },
  { width: "650" },
  { width: "539" },
  { width: "444" },
  { width: "400" },
  { width: "382" },
];


// WEBPACK FOOTER //
// ./src/pages/gallery/15f/data15f.js